import { cosmeticGlyphs, glyphTypes } from "./glyph-types";
import { perkConnections, perks } from "./perks";

import { automator } from "./automator";
import { glyphCosmeticSets } from "./glyph-cosmetics";
import { glyphEffects } from "./glyph-effects";
import { glyphSacrifice } from "./glyph-sacrifices";
import { imaginaryUpgrades } from "./imaginary-upgrades";
import { realityUpgrades } from "./reality-upgrades";

export const reality = {
  automator,
  cosmeticGlyphs,
  glyphCosmeticSets,
  glyphEffects,
  glyphSacrifice,
  glyphTypes,
  imaginaryUpgrades,
  perks,
  perkConnections,
  upgrades: realityUpgrades
};
